/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


export default class
{
  constructor (dock)
  {
    this.dock = dock;
  }


  isExternalBorder (neighbor)
  {
    const neighborDock = neighbor.getDock() || neighbor.getPlatform();

    return !neighborDock || this.dock.getUserID() != neighborDock.getUserID();
  }


  isGroupBorder (neighbor)
  {
    return false;
  }


}

